<template>
  <div class="form-item">
    <label class="form-label">{{ label }}</label>

    <div class="filters-search">
      <input
          class="input-slim"
          type="search"
          :value="modelValue"
          :placeholder="placeholder"
          @input="onInput"
      >
      <button
          v-if="modelValue"
          class="btn-square btn-search"
          type="button"
          @click="clear"
      >
        <svg class="svg-search">
          <use href="/img/sprite.svg#svg-cross"></use>
        </svg>
      </button>
      <button
          v-else
          class="btn-square btn-search"
          type="button"
      >
        <svg class="svg-search">
          <use href="/img/sprite.svg#svg-search"></use>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FieldSearchFilter',
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: 'Поиск',
    },
    fields: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update:modelValue', 'search'],
  methods: {
    onInput(event) {
      const value = event.target.value;
      this.$emit('update:modelValue', value);
      this.$emit('search', value, this.fields);
    },
    clear() {
      this.$emit('update:modelValue', '');
      this.$emit('search', '', this.fields);
    },
  },
};
</script>